var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 3.42857C9.08727 3.42857 9.81273 2.66286 9.81273 1.71429C9.81273 0.765714 9.08727 0 8.18182 0C7.27636 0 6.54545 0.765714 6.54545 1.71429C6.54545 2.66286 7.27636 3.42857 8.18182 3.42857ZM3.81818 3.42857C4.72364 3.42857 5.44909 2.66286 5.44909 1.71429C5.44909 0.765714 4.72364 0 3.81818 0C2.91273 0 2.18182 0.765714 2.18182 1.71429C2.18182 2.66286 2.91273 3.42857 3.81818 3.42857ZM3.81818 4.57143C2.54727 4.57143 0 5.24 0 6.57143V8H7.63636V6.57143C7.63636 5.24 5.08909 4.57143 3.81818 4.57143ZM8.18182 4.57143C8.02364 4.57143 7.84364 4.58286 7.65273 4.6C8.28545 5.08 8.72727 5.72571 8.72727 6.57143V8H12V6.57143C12 5.24 9.45273 4.57143 8.18182 4.57143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.980215b48872d24ee6f81cdc1de4f0f9.svg";
export { ForwardRef as ReactComponent };